import createAxiosInstance from "./axios";
import { ADMIN_APP_API_PREFIX } from "./apiUtils";

const api = createAxiosInstance(ADMIN_APP_API_PREFIX);

export default api;
